$( document ).ready(function() {
    if($(".template-collection").length){
        if(!sessionGet('tada_session')){
            $(".template-collection").html(`
                <link rel="stylesheet" href="${$("body").attr("data-css")}">
                <section class="member-hero">
                    <div class="member-main">
                        <div class="member-card">
                            <form method="post" id="check-member">
                                <h1>WELCOME</h1>
                                <p class="info-number">Please log in to continue</p>
                                <label for="" class="">Phone Number</label>
                                <div class="form-group-phone" style="">
                                    <div class="form-group form-group-custom" style="max-width: 8.5rem">
                                    <!-- <label for="">Country Code</label> -->
                                    <input type="tel" data-mask="000" name="country_code" id="phone_area" class="form-control  country-code-trigger" placeholder="Country Code" value="+62" autocomplete="off" maxlength="3" required="required" disabled>
                                    </div>
                                    <div class="form-group form-group-custom">
                                    <input type="tel" data-mask="000000000000" name="phone_number" class="form-control " placeholder="Ex. 812348718" value="" autocomplete="off" maxlength="12" required="required">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button class="btn btn-dark w-100 text-uppercase" type="submit"> Continue </button>
                                </div>
                            </form>
                            <div class="otp-login"></div>
                        </div>
                    </div>
                </section>    
            `).removeClass("gradient")
        }
        else{
            $(".member-check--css").remove();
        }

        let memberBaseUrl = "https://member-id.devbdd.com/"

        function otpInput() {
            var otpGroup = setInterval(() => {
                if ($(".otp-group").length) {
                    $('.otp-group').find('input').each(function() {
                        $(this).attr('maxlength', 1);
                        $(this).on('keyup', function(e) {
                            var parent = $($(".otp-group"));

                            if (e.keyCode === 8 || e.keyCode === 37) {
                                var prev = parent.find('input#' + $(this).data('previous'));

                                if (prev.length) {
                                    $(prev).select();
                                }
                            } else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 39) {
                                var next = parent.find('input#' + $(this).data('next'));

                                if (next.length) {
                                    $(next).select();
                                }
                            }
                        });
                    });

                    clearInterval(otpGroup)
                }
            }, 1000);
        }

        let dataToPost = {
            'shop': "atmos-indonesia.myshopify.com",
            'customer_id': "",
        }
        
        $(document).on("submit", "#check-member", function(e) {
            e.preventDefault()
            $(".tada-signin .error-notif").remove()
            $(".response-lt").html("")
            $(this).find("button").html("Please wait...").attr("disabled", true)
            let phone_number = $(this).find("[name=phone_number]").val()
        
            dataToPost['phone'] = phone_number;
        
            setTimeout(() => {
                $.ajax({
                    type: "POST",
                    url: memberBaseUrl + "member/getMemberOnWebsite",
                    data: dataToPost,
                    success: function(response) {
                        let data = JSON.parse(response)
                        $("#check-member").find("button").html("Continue").attr("disabled", false)
        
                        if (data['status'] == 200) {
                            $.ajax({
                                type: "POST",
                                url: memberBaseUrl + "member/sendOtpOnly",
                                data: dataToPost,
                                success: function(response) {
                                    let data = JSON.parse(response)
        
                                    if (data['status'] == 200) {
                                        $("#check-member").remove()
                                        $(".info-number").html("Enter your OTP").addClass("text-center")
                                        $(".otp-login").html(`
                                            <form action="${memberBaseUrl}member/verifyOtpOnly" method="post" id="verifyOtpOnly">
                                                <h1>OTP</h1>
                                                <p class="info-number">Please verify your OTP</p>
                                                <div class="form-group otp-group">
                                                <div class="otp-item">
                                                    <input type="text" id="digit-1" name="digit-1" data-next="digit-2" />
                                                </div>
                                                <div class="otp-item">
                                                    <input type="text" id="digit-2" name="digit-2" data-next="digit-3" data-previous="digit-1" />
                                                </div>
                                                <div class="otp-item">
                                                    <input type="text" id="digit-3" name="digit-3" data-next="digit-4" data-previous="digit-2" />
                                                </div>
                                                <div class="otp-item">
                                                    <input type="text" id="digit-4" name="digit-4" data-previous="digit-3" />
                                                </div>
                                                </div>
                                                <div class="form-group submit-btn-member">
                                                    <button class="btn btn-dark w-100 text-uppercase">Verify OTP</button>
                                                </div>
                                            </form>
                                        `)
        
                                        otpInput()
                                    } else {
                                        // $(".response-lt").after(`${data['message']}`)
                                        var t = document.createElement("span");
                                        t.className = "Alert Alert--error atc-notif", t.innerHTML = data['message'];
        
                                        $("body").prepend(t)
                                        setTimeout(() => {
                                            t.className += " active";
                                        }, 200);
                                        setTimeout(function() {
                                            t.classList.remove("active");
                                            setTimeout(() => {
                                                t.remove()
                                            }, 500);
                                        }, 2700)
                                    }
                                }
                            });
                        } else {
                            var t = document.createElement("span");
                            t.className = "Alert Alert--error atc-notif", t.innerHTML = "You're not registered as member, please contact administrator.";
        
                            $("body").prepend(t)
                            setTimeout(() => {
                                t.className += " active";
                            }, 200);
                            setTimeout(function() {
                                t.classList.remove("active");
                                setTimeout(() => {
                                    t.remove()
                                }, 500);
                            }, 2700)
                        }
                    }
                });
            }, 1500);
        })
        
        $(document).on("submit", "#verifyOtpOnly", function(e) {
            e.preventDefault();
        
            var postUrl = $(this).attr("action") ?? `${memberBaseUrl}member/verifyOtpOnly`
            var otpValue = '';
            $('#verifyOtpOnly .otp-group input').each(function() {
                otpValue += $(this).val();
            });
        
            dataToPost['otp'] = otpValue;
        
            $.ajax({
                type: "POST",
                url: postUrl,
                data: dataToPost,
                beforeSend: function() {
                    $("#verifyOtpOnly .submit-btn-member button").attr("disabled", true).html("Please wait...")
                },
                success: function(response) {
                    let data = JSON.parse(response);
        
                    if (data['status'] == 200 || data['status'] == 201) {
                        sessionSet('tada_session', dataToPost['phone'] ?? data['status']);
                        location.reload();
                    } else {
                        $("#verifyOtpOnly .submit-btn-member button").attr("disabled", false).html("Verify OTP")
                        // $(".response-lt").html(`${data['message']}`)
                        var t = document.createElement("span");
                        t.className = "Alert Alert--error atc-notif", t.innerHTML = data['message'];
        
                        $("body").prepend(t)
                        setTimeout(() => {
                            t.className += " active";
                        }, 200);
                        setTimeout(function() {
                            t.classList.remove("active");
                            setTimeout(() => {
                                t.remove()
                            }, 500);
                        }, 2700)
                    }
                }
            })
        })
    }

    $("#booking-product").click(function(){
        let product_handle = $(this).attr("data-handle")
        let product_id = $("[name='product-id']").val()
        let variant_id = $(".product-variant-id").val()
        let url_page = $(this).attr("data-page")

        let data_booking = {
            product_id: product_id,
            variant_id: variant_id
        }

        localStorage.setItem('item_booking', JSON.stringify(data_booking));
        location.href = `https://${Shopify.shop}${url_page}?product=${product_handle}`
    })

    if($(".booking-product").length){
        $("body").html($(".booking-product")).show();

        let memberBaseUrl = "https://member-id.devbdd.com/"
        let data_session = JSON.parse(localStorage.getItem("tada_session"))
        let product_selected = JSON.parse(localStorage.getItem("item_booking"))

        if (data_session == null) {
            location.href = `https://${Shopify.shop}`
        }

        let phone = data_session.phone;
        let campaign = $(".booking-product").attr("data-campaign")
        let store = $(".booking-product").attr("data-store")
        let dataToPost = {
            'shop': store,
            'customer_id': "",
            'phone': phone
        }

        var handle = getParameterByName('product');
        if (handle) {
            $.ajax({
                url: '/products/' + handle + '.js',
                dataType: 'json',
                success: function(product) {
                    const variant_selected = product.variants.find(variant => variant.id == product_selected.variant_id);
                    localStorage.setItem("variant_selected", JSON.stringify(variant_selected))

                    let product_variant_name = product.title;
                    if (variant_selected != null) {
                        product_variant_name = variant_selected.name;
                    }

                    checkMember(memberBaseUrl, dataToPost)
                    dataToPost['campaign'] = campaign
                    dataToPost['url_shopify'] = Shopify.shop

                    $.ajax({
                        type: "POST",
                        url: memberBaseUrl + "booking/getEarlyBooking",
                        data: dataToPost,
                        success: function(response) {
                            let result = JSON.parse(response)
                            if (result.status == 200) {
                                let data_booking = JSON.parse(result.data_booking)
                                let product = JSON.parse(data_booking.product)

                                let product_variant_name = data_booking.product_name;

                                $("#booking-form").html(`
                                    <div class="booked-detail">
                                        <div style="">
                                        <h1 class="booking-title">Thank you for your submission! Your details have been successfully recorded.</h1>
                                        <p>No. Order: <b>${data_booking.order_name}</b></p>
                                        <p>Name: <b>${data_booking.name}</b></p>
                                        <p>Email: <b>${data_booking.email}</b></p>
                                        <p>Phone: <b>0${data_booking.phone}</b></p>
                                        <p>Product: <b>${product_variant_name}</b></p>
                                        <p class="info-detail">${result.info_detail}</p>
                                        </div>
                                    </div>
                                `)

                                if (result.phone_number != null && data_booking.opsi == 2) {
                                    setTimeout(() => {
                                        var phoneNumber = result.phone_number;
                                        var message = `Hi, please proceed my booking:\n\nNo. Order: ${data_booking.order_name}\nEmail: ${data_booking.email}\nProduct: ${product.name}${product_variant_name}\n\nThankyou.`;
                                        var url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

                                        location.href = url
                                    }, 1000);
                                }
                            }
                        },
                        error: function() {
                            notif(2, "Error, please refresh page")
                        }
                    })

                    var typeValue = "";
                    product.tags.forEach(function(tag) {
                        if (tag.startsWith('type-')) {
                            typeValue = tag.split('type-')[1];
                        }
                    });
                    localStorage.setItem("type_selected", '"' + typeValue + '"')

                    $(".booking-product--name").html(product_variant_name)
                    localStorage.setItem('booking-product', JSON.stringify({
                        id: product.id,
                        name: product.title,
                        image: product.featured_image,
                        variants: product.variants
                    }), 1);
                },
                error: function() {
                    // jika produk tidak ditemukan / error, kembali ke halaman sebelumnya
                    window.history.back();
                }
            });
        } else {
            window.history.back();
        }

        $(document).on("submit", "#booking-form", function(e) {
            e.preventDefault();
            $("#booking-form .btn").html("Please wait...").attr("disabled", "disabled")
            const variant_selected = JSON.parse(localStorage.getItem("variant_selected"));
            let type_selected = JSON.parse(localStorage.getItem("type_selected"));
            let size = ""

            data_session = JSON.parse(localStorage.getItem("tada_session"))
            phone = data_session.phone;
            dataToPost['phone'] = phone;

            $.ajax({
                type: "POST",
                url: memberBaseUrl + "member/getMemberOnWebsite",
                data: dataToPost,
                success: function(response) {
                    let data = JSON.parse(response)
                    if (data['status'] == 200) {
                        let product = localStorage.getItem("booking-product")
                        let data_booking = {
                            url_shopify: Shopify.shop,
                            name: $("#booking-form input#name").val(),
                            email: $("#booking-form input#email").val(),
                            opsi: '',
                            phone: phone,
                            product: product,
                            product_name: variant_selected.name,
                            product_type: type_selected,
                            variant_id: variant_selected.id,
                            campaign: campaign,
                            size: size,
                            address: $("#booking-form #address").val()
                        }

                        // console.log(data_booking)

                        $.ajax({
                            type: "POST",
                            url: memberBaseUrl + "booking/earlyBooking",
                            data: data_booking,
                            success: function(response) {
                                let result = JSON.parse(response)

                                if (result.status == 200) {
                                    notif(1, result.message)
                                    location.reload()
                                } else {
                                    $("#booking-form .btn").html("Booking").attr("disabled", false)
                                    notif(2, result.message)
                                }
                            },
                            error: function() {
                                notif(2, "Error, please refresh page")
                            }
                        });
                    } else {
                        notif(2, "You're not regitered as member")
                        location.href = `https://${Shopify.shop}`
                    }
                }
            });
        })
    }

    if($("#booking-product-payment").length){
        let memberBaseUrl = "https://member-id.devbdd.com/"
        let data_session = JSON.parse(localStorage.getItem("tada_session"))

        if (data_session == null) {
            location.href = `https://${Shopify.shop}`
        }

        let phone = data_session.phone
        let data_check = {
            phone: phone,
            campaign: $("#booking-product-payment").attr("data-campaign"),
            product_type: $("#booking-product-payment").attr("data-type")
        }

        $.ajax({
            type: "POST",
            url: memberBaseUrl + "member/getMemberOnWebsite",
            data: {phone: phone, shop: Shopify.shop, customer_id: ""},
            success: function(response) {
                let data = JSON.parse(response)
                if (data['status'] == 200) {
                    checkAddToCart(data_check, function(result) {
                        if(result.status == 200){
                            $("variant-selects").show()
                            // if($(".fcfs-button").length < 1){
                                $("#booking-product-payment").show()
                            // }
                        }
                        else{
                            $("#booking-product-payment").remove()
                            $("variant-selects").remove()
                            $("product-info").append("<p>You can't order this product</p>")

                            if($(".fcfs-button").length){
                                $(".fcfs-button").remove()
                            }
                        }
                    });
                } else {
                    notif(2, "You're not regitered as member")
                    location.href = `https://${Shopify.shop}`
                }
            }
        });

        // $(document).on("click", "#booking-product-payment", function(e){
        //     e.preventDefault();
        //     $("#booking-product-payment").html("Please wait..").attr("disabled", "disabled")
            
        //     checkAddToCart(data_check, function(result) {
        //         if(result.status == 200){
        //             setTimeout(() => {
        //                 $("#booking-product-payment").html("ADD TO CART").removeAttr("disabled")
        //                 $(`form[data-type="add-to-cart-form"]`).trigger("submit")
        //             }, 1000)
        //         }
        //         else if(result.status == 400){
        //             notif(2, result.message)
        //             location.reload();
        //         }
        //     });
        // })
    }

    if($("[booking-item]").length == 1){
        let data_session = JSON.parse(localStorage.getItem("tada_session"))
        if (data_session == null) {
            location.href = `https://${Shopify.shop}`
        }

        let phone = data_session.phone
        let data_check = {
            phone: phone,
            campaign: $("[booking-item]").attr("data-campaign"),
            product_type: $("[booking-item]").attr("data-type")
        }
        
        checkAddToCart(data_check, function(result) {
            if(result.status == 400){
                let remove_url = $("[booking-item]").find(".remove-href").attr("href");
                location.href = remove_url
            }
        });
    }

    if($(".template-product").length){
        $(".shopify-payment-button__button").html("BUY NOW")
    }

    if(location.href.includes("collections/all")){
        location.href = "/collections/speedcat-beautiful-people-x-atmos-speedcat-og"
    }
});